import React from 'react';

// Підтягуємо всі PNG із src/img/icons (тільки з цієї папки, без підпапок)
const ctx = require.context('../img/icons', false, /\.png$/);

/** Створюємо мапу: 'FileName' -> url */
const ICONS = ctx.keys().reduce((acc, key) => {
  const name = key.replace('./', '').replace(/\.png$/i, ''); // наприклад "ChartBar"
  acc[name] = ctx(key);
  return acc;
}, {});

/**
 * Використання:
 * <IconPng name="ChartBar" size={28} />
 * name = ім'я файлу без .png (регістр ВАЖЛИВИЙ)
 */
export default function IconPng({ name, size = 24, className = '', alt }) {
  const src = ICONS[name];
  if (!src) {
    // щоб легше дебажити, якщо раптом назва не співпала
    console.warn(`[IconPng] Не знайдено іконку: ${name}.png у src/img/icons/`);
    return null;
  }
  return (
    <img
      src={src}
      width={size}
      height={size}
      className={`icon ${className}`}
      alt={alt || name}
      loading="lazy"
      decoding="async"
    />
  );
}
